import Vue from 'vue'
import VeeValidate from 'vee-validate'
import VeeValidateEnMessages from 'vee-validate/dist/locale/en'
import VeeValidateHuMessages from 'vee-validate/dist/locale/hu'
import { i18n } from '@/plugins/i18n'
import '@/validators/Validators'

Vue.use(VeeValidate, {
    fieldsBagName: 'veeFields',
    i18n,
    i18nRootKey: 'validations',
    dictionary: {
        en: VeeValidateEnMessages,
        hu: VeeValidateHuMessages,
    },
    useConstraintAttrs: false,
    delay: 300,
})

// vee-validate's directive hooks run while Vue patches the component that owns the field, i.e. while
// it records that component's render dependencies, and they read the field / error lists that every
// validator shares. Each component with a validated field therefore re-rendered whenever any field of
// any form attached or validated (tasks#211). The hooks now run inside a throwaway watcher, which Vue's
// own target stack makes the collector (also around the watchers the hooks create), and whose
// dependencies are dropped afterwards. What a template shows (errors, fields flags) is still read by its
// render and stays reactive.
const scratch = new Vue()
scratch.$watch(
    () => null,
    () => {}
)
const Watcher = scratch._watchers[0].constructor

function untracked(fn, context, args) {
    let result
    const watcher = new Watcher(
        scratch,
        () => {
            result = fn.apply(context, args)
        },
        () => {},
        { lazy: true }
    )
    try {
        watcher.get()
    } finally {
        watcher.teardown()
    }
    return result
}

const directive = Vue.options.directives.validate

;['bind', 'inserted', 'update', 'componentUpdated', 'unbind'].forEach(
    (hook) => {
        const original = directive[hook]
        if (typeof original !== 'function') return
        directive[hook] = function (...args) {
            return untracked(original, this, args)
        }
    }
)
